import React, { useState, useEffect } from 'react';
import "./About.scss";

const About = () => {
  const [heightOver, setHeightOver] = useState(false);
  const [heightOver2, setHeightOver2] = useState(false);
  useEffect(() => {
    const scrollAction = () => {
      if (450 < window.scrollY) {
        setHeightOver(true);
      }
    };
    const scrollAction2 = () => {
      if (450 < window.scrollY) {
        setHeightOver2(true);
      }
    }
    window.addEventListener("scroll", scrollAction,  {
      capture: false,
      passive: true,
    });
    window.addEventListener("scroll", scrollAction2,  {
      capture: false,
      passive: true,
    });
    scrollAction();
    scrollAction2();
    return () => {
      window.removeEventListener("scroll", scrollAction);
      window.removeEventListener("scroll", scrollAction2);
    };
  }, []);
  return (
    <div className="about-container">
      <div className="about-background"></div>

      <div className="title-box">
        <h2 className={heightOver ? "title-h2" : "scroll"}><span>About</span><span>me</span></h2>
        <p className={heightOver ? "title-p" : "scroll"}>プロフィール</p>
        <div className={heightOver ? "title-back" : "scroll"}></div>
        <div className={heightOver ? "title-back2" : "scroll"}></div>
      </div>

        <div className={heightOver2 ? "about-wrapper" : "scroll"}>
          <div className="profile-wrapper">
            <ul>
              <li>Name</li>
              <li>Birthday</li>
              <li>Github</li>
              <li>Twitter</li>
            </ul>
            <ul>
            <li><i class="fas fa-user"></i>岡村隼斗<span>(オカムラハヤト)</span></li>
              <li><i class="fas fa-birthday-cake"></i>2001年<span>10月</span><span>12日</span></li>
              <li><a href="https://github.com/HayatoOkamura"><i class="fab fa-github"></i>https://github.com/HayatoOkamura</a></li>
              <li><a href="https://twitter.com/_Hayato_guitar_">
              <i class="fab fa-twitter"></i>@_Hayato_guiter_ </a></li>
             
            </ul>

              <img src="images/image1.JPG"></img>

          </div>
          <div className="skill-wrapper">
            <h3>Skills</h3>
            <p>HTML / CSS / SASS / JavaScript / React.js / node.js / Typescript / jQuery / Firebase / PHP / MySQL / Git</p>
          </div>
          <div className="message-wrapper">
            <h3>Message</h3>
            <p>
              初めまして岡村隼斗と申します。フリーランスのイラストレーターとして1年半ほど働きながら、独学でプログラミングの学習をしました。<br/>
            もともと趣味で始めたHTML,CSSですが、ある時デザイナーである田渕将吾氏のポートフォリオサイトを見て衝撃を受け、プログラミングにはクリエイターとして無限の可能性を秘めていると感じ田渕将吾氏のような開発もデザインもできるエンジニアになりたいと思い、WEBエンジニアとして就職することを決めました。<br />
            UI / UXデザインやReact.jsによるSPA開発を主に学習し、よりリッチなWebページを制作するためにPHP,MySQLを用いた開発にも挑戦しました。全て独学で学んだのでまだ荒削りなところは多いと思いますが、エンジニアにおいて重要なスキルである「調べる能力」には自信があります。今後はReactを中心にNext.js,React18などの理解を深めたり、実務に必要な知識を適宜身につけたいと思います。
            </p>
          </div>
          <div className="hobby-wrapper">
            <h3>Hobby</h3>
            <p>イラスト・ギター・麻雀・筋トレ・音楽鑑賞・野球・タイピング練習</p>
          </div>
        </div>

      </div>
  )
}

export default About;